import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('applicationDetailsPage');

    return {
        ACRES: t('acres'),
        ACTIVITY: t('activity'),
        EDIT_APPLICATION: t('editApplication'),
        GALLONS: t('gallons'),
        LINKED_ENTITIES: t('linkedEntities')
    };
};

export default useTranslation;
